

var slideIndex = 1;

//Slide control
function plusSlides(n) {
  showSlides(slideIndex += n);
}

//Move to n slide
function showSlides(n) {
  var i;
  var slides = $(".okendo-slide");
  if (n > slides.length) {slideIndex = 1}
  if (n < 1) {slideIndex = slides.length}
  for (i = 0; i < slides.length; i++) {
    slides[i].style.display = "none";
  }

  slides[slideIndex-1].style.display = "block";
}

//Execute on review widget initialize then clone aggegrate review
window.okeReviewsWidgetOnInit = function() {

  var reviewAttributes = $(".okeReviews-reviewsAggregate-ratingDistribution").clone();
  if(reviewAttributes[0]){
      // reviewAttributes.className = "okeReviews-reviewsAggregate-ratingDistribution";
      var reviewSummary = $(".okeReviews-reviewsAggregate-summary").clone();
      // reviewSummary.className = "okeReviews-reviewsAggregate-summary";
      var widgetContainer = $(".okendo-mini-aggregate-container");
      widgetContainer.prepend(reviewAttributes[0]);
      widgetContainer.prepend(reviewSummary[0]);
      cloneReviews()
      showSlides(slideIndex);
      $(".okendo-mini-widget")[0].style.display="block";

  }

}

//Copy the review and create individual slide to add to carousel
function cloneReviews(){
  var reviewTitles = $(".okeReviews-review-main-heading").clone();
  var reviewStars = $(".okeReviews-review-starRating").clone();
  var profileImages = $(".js-okeReviews-reviewerProfile").clone();
  var reviewContents = $(".js-okeReviews-reviewContent").clone();
  var carousel = $(".okendo-mini-review-carousel");
  for(i = 0; i < reviewTitles.length; i++){
    var slide = document.createElement( "div");
    slide.className = "okendo-slide fadeSlide";
    slide.append(profileImages[i]);
    slide.append(reviewStars[i]);
    slide.append(reviewTitles[i]);
    slide.append(reviewContents[i]);
    carousel.append(slide);
  }
}

//Add on click method to show more to scroll down to the bigger widget
$(document).ready(function() {
  $('.okendo-show-more').click(function(e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: $('.okeReviews-widget-holder').offset().top
    }, 500);
  });
});
